import { ObservableFromFetch } from "../ObservableFromFetch"
import { ImplementationGroupID_Workforce } from "../../config/Constants"
import AccountLabResultsReporting from "./CompanyModel/AccountLabResultsReporting"



export default function AccountLabResultsReportingGet(implementationId: number) {
  const requestBody: string = new URLSearchParams({
    implementationId: implementationId.toString()
  }).toString()
  return ObservableFromFetch<AccountLabResultsReporting[]>("WorkforceLabResultsReporting/GetAccounts?" + requestBody)
}

export  function SetAccountLabResultsReporting(data: AccountLabResultsReporting) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("WorkforceLabResultsReporting/SetAccountLabResultsReporting", requestBody)
}
